import { companyPolicyConstants } from '../../_constants';

export function companyPolicies(state = {}, action) {
    switch (action.type) {
        case companyPolicyConstants.COMPANY_FETCHING:
            return {
                ...state,
                COMPANYfetching: true
            };
        case companyPolicyConstants.COMPANY_FETCHED:
            return {
                ...state,
                COMPANYfetching: false
            };
        case companyPolicyConstants.COMPANY_SUBMITING:
            return {
                ...state,
                COMPANYSubmiting: true
            };
        case companyPolicyConstants.COMPANY_SUBMITED:
            return {
                ...state,
                COMPANYSubmiting: false
            };
        case companyPolicyConstants.GET_ALL_COMPANY_POLICIES:
            return {
                ...state,
                companyPolicies: action.companyPolicies
            };
        case companyPolicyConstants.GET_COMPANY_POLICIES:
            return {
                ...state,
                companyPolicies: action.companyPolicies
            };
        case companyPolicyConstants.GET_COMPANY_POLICY_BY_ID:
            return {
                ...state,
                companyPolicy: action.companyPolicy
            };
        case companyPolicyConstants.UPDATE_COMPANY_POLICY:
            return {
                ...state,
                updating: true
            };
        case companyPolicyConstants.SEARCH_COMPANY_POLICIES:
            return {
                ...state,
                companyPolicies: action.companyPolicies
            };
        default:
            return state;
    }
}